<span class="alert-container">
  @if (linked) {
    <a [queryParams]="{alert: alertTypes()}" [routerLink]="project | url">
      <app-alert-icon [alerts]="groupedAlerts" [smallIcon]="true"></app-alert-icon>
    </a>
  } @else {
    <app-alert-icon [alerts]="groupedAlerts" [smallIcon]="true"></app-alert-icon>
  }
</span>
